export const countryFallbacks = {
    AE: {latitude: 25.2048, longitude: 55.2708}, // Dubai, Utd.Arab Emir.
    AR: {latitude: -34.6037, longitude: -58.3816}, // Buenos Aires, Argentina
    AT: {latitude: 48.2082, longitude: 16.3738}, // Vienna, Austria
    AU: {latitude: -33.8688, longitude: 151.2093}, // Sydney, Australia
    BE: {latitude: 50.8503, longitude: 4.3517}, // Brussels, Belgium
    BG: {latitude: 42.6975, longitude: 23.3242}, // Sofia, Bulgaria
    CA: {latitude: 45.4215, longitude: -75.6997}, // Ottawa, Canada
    CH: {latitude: 46.9481, longitude: 7.4474}, // Bern, Switzerland
    CN: {latitude: 39.9042, longitude: 116.4074}, // Beijing, China
    CZ: {latitude: 50.0755, longitude: 14.4378}, // Prague, Czech Republic
    DE: {latitude: 52.52, longitude: 13.405}, // Berlin, Germany
    DK: {latitude: 55.6761, longitude: 12.5683}, // Copenhagen, Denmark
    EE: {latitude: 59.437, longitude: 24.7536}, // Tallinn, Estonia
    EG: {latitude: 30.0444, longitude: 31.2357}, // Cairo, Egypt
    ES: {latitude: 40.4168, longitude: -3.7038}, // Madrid, Spain
    FI: {latitude: 60.1695, longitude: 24.9354}, // Helsinki, Finland
    FR: {latitude: 48.8566, longitude: 2.3522}, // Paris, France
    GB: {latitude: 51.5072, longitude: -0.1276}, // London, Great Britain
    GR: {latitude: 37.9838, longitude: 23.7275}, // Athens, Greece
    HK: {latitude: 22.3193, longitude: 114.1694}, // Hong Kong, Hong Kong
    HR: {latitude: 45.815, longitude: 15.9819}, // Zagreb, Croatia
    HU: {latitude: 47.4979, longitude: 19.0402}, // Budapest, Hungary
    IE: {latitude: 53.3498, longitude: -6.2603}, // Dublin, Ireland
    IS: {latitude: 64.1355, longitude: -21.8954}, // Reykjavik, Iceland
    IT: {latitude: 41.9028, longitude: 12.4964}, // Rome, Italy
    JP: {latitude: 35.6895, longitude: 139.6917}, // Tokyo, Japan
    KR: {latitude: 37.5665, longitude: 126.978}, // Seoul, South Korea
    LT: {latitude: 54.6872, longitude: 25.2797}, // Vilnius, Lithuania
    LU: {latitude: 49.6117, longitude: 6.1319}, // Luxembourg, Luxembourg
    LV: {latitude: 56.9496, longitude: 24.1052}, // Riga, Latvia
    MY: {latitude: 3.139, longitude: 101.6869}, // Kuala Lumpur, Malaysia
    MX: {latitude: 19.4326, longitude: -99.1332}, // Mexico City, Mexico
    NL: {latitude: 52.3676, longitude: 4.9041}, // Amsterdam, Netherlands
    NO: {latitude: 59.9139, longitude: 10.7522}, // Oslo, Norway
    NZ: {latitude: -36.8485, longitude: 174.7633}, // Auckland, New Zealand
    PL: {latitude: 52.2297, longitude: 21.0122}, // Warsaw, Poland
    PT: {latitude: 38.7169, longitude: -9.1399}, // Lisbon, Portugal
    RO: {latitude: 44.4268, longitude: 26.1025}, // Bucharest, Romania
    RS: {latitude: 44.7866, longitude: 20.4489}, // Belgrade, Serbia
    SE: {latitude: 59.3293, longitude: 18.0686}, // Stockholm, Sweden
    SG: {latitude: 1.3521, longitude: 103.8198}, // Singapore, Singapore
    SI: {latitude: 46.0569, longitude: 14.5058}, // Ljubljana, Slovenia
    SK: {latitude: 48.1486, longitude: 17.1077}, // Bratislava, Slovakia
    US: {latitude: 37.7749, longitude: -122.4194}, // San Francisco, USA
    WW: {latitude: 50.8503, longitude: 4.3517}, // Brussels, International site
    SA: {latitude: 24.7136, longitude: 46.6753}, // Riyadh, Saudi Arabia
}

export const getFallbackCoordinates = (countryCode) => {
    return countryFallbacks[countryCode] || countryFallbacks['IT'] // Default: Italia
}

export const generateGoogleMapsLinkFromAddress = (storeName, address) => {
    const query = encodeURIComponent(`${storeName}, ${address}`)
    return `https://www.google.com/maps/search/?api=1&query=${query}`
}
